import {
  hasPermissionToAccess,
  PERMISSION_TYPE,
} from '@common-packages/customer-permissions-utils';
import { Routes } from '@common-packages/routes-definitions';

import { CustomerPermissionsProps } from '../../shared/propTypes/customerPropTypes';

const hasPermissionToIgnoreEfileDiagnostics = (customerPermissions: CustomerPermissionsProps) =>
  hasPermissionToAccess({
    customerPermissions,
    permissionType: PERMISSION_TYPE.EDIT,
    routeDefinitions: [Routes.eFileDiagnostics.MAIN],
  });

export default hasPermissionToIgnoreEfileDiagnostics;
